<template>
  <mobile-card>
    <template slot="title">
      <div class="charge-card-title">
        {{ item.itemName }}
      </div>
    </template>

    <template slot="content">
      <div class="flex-form-info">
        <div class="left">交费区间</div>
        <div class="right">{{ intervalName }}</div>
      </div>
      <div class="flex-form-info" v-if="item.feeMode === 5 && item.forceConnDeclareWhenCharge === 1">
        <div class="left">标准名称</div>
        <div class="right">{{ declareStd.declareStdName }}</div>
      </div>
      <div class="flex-form-info">
        <div class="left">{{ item.editMoney ? "交费金额" : "单价" }}</div>
        <div class="right" v-if="moneys && moneys.length > 0" style="min-width: 100px;">
          <van-dropdown-menu style="float:right;" active-color="#125b2f">
            <van-dropdown-item v-model="dropDownMoney" :options="moneys" />
          </van-dropdown-menu>
        </div>
        <div class="right" v-else-if="!item.editMoney && declareStd.money" style="min-width: 100px;">
          <div style="float:right;">{{ declareStd.money }} {{ declareStd.specUnit }}</div>
        </div>
        <div class="right" v-else-if="item.editMoney">
          <!--                    <van-icon v-show="hiddenEdit" name="edit" @click="onEdit"/>-->
          <van-field
            ref="moneyRef"
            v-model="money"
            style="height: 28px;padding: 0px;width: 150px;float:right;"
            clearable
            autofocus
            right-icon="edit"
            @click-right-icon="$refs.moneyRef.focus()"
            placeholder="请填入交费金额"
            type="number"
            input-align="right"
          ></van-field>
          <!--                    <div v-show="!hiddenEdit" class="input-border">-->
          <!--                       -->
          <!--                    </div>-->
        </div>
        <div class="right link" style="text-decoration:none;" v-else>{{ money | formatMoney }}</div>
      </div>
      <div class="flex-form-info">
        <div class="left">数量</div>
        <div class="right" v-if="!item.canChangeCount">
          {{ count }}
        </div>
        <div class="right" v-else>
          <van-stepper v-model="count" step="1" integer />
        </div>
      </div>
      <div class="flex-form-info" style="height: 14px;" v-if="!showRemark">
        <!--@click.prevent="showRemark=true"-->
        <div class="left link" @click.prevent="showRemark = !showRemark" style="font-size: 12px;">填写收费备注</div>
      </div>
      <div class="flex-form-info" style="height: auto" v-if="showRemark">
        <div class="left link" style="font-size: 12px;" @click.prevent="showRemark = !showRemark">收起收费备注</div>
      </div>
      <div class="flex-form-info" style="height: auto" v-if="showRemark">
        <div style="width:100%;">
          <van-field
            input-align="left"
            label-align="right"
            size="14px"
            class="text-field"
            v-model="itemRemark"
            rows="2"
            style="padding: 0px; margin: 0px; padding-right: 5px; text-align:right;font-size:13px;"
            autosize
            type="textarea"
            maxlength="200"
            show-word-limit
            placeholder="请填入收费备注"
          />
        </div>
      </div>
    </template>
  </mobile-card>
</template>
<script>
import MobileCard from "components/mobile-card/index";
import util from "utils/util";

export default {
  name: "chargeCard",
  components: { MobileCard },
  props: {
    item: Object,
  },
  data() {
    return {
      hiddenEdit: true,
      checked: false,
      count: 1,
      money: 0,
      dropDownMoney: "",
      sumMoney: 0,
      itemRemark: "",
      intervalId: "",
      intervalName: "",
      intervalSpecId: "",
      declareNum: "",
      showRemark: false,
      moneys: [],
      declareStd: {},
    };
  },
  watch: {
    count(newVal) {
      this.sumMoney = this.money * newVal;
    },
    money() {
      this.sumMoney = this.money * this.count;
    },
    dropDownMoney(newVal) {
      this.money = newVal.toString().split("#ABC#")[1];
    },
    sumMoney() {
      this.$emit("changeSumMoney", this.sumMoney);
    },
  },
  methods: {
    moneyFormat(money) {
      return this.$options.filters.formatMoney(money);
    },
    getParam() {
      if (this.money > 0) {
        if (this.item.feeMode === 3 && this.item.maxMoney > 0) {
          if (this.money > this.item.maxMoney) {
            this.$notify({
              type: "warning",
              message: "最大交费金额为：" + this.moneyFormat(this.item.maxMoney) + "元。",
            });
            return;
          }
        }
        let arr = [];
        arr.push({
          itemId: this.item.itemId,
          itemName: this.item.itemName,
          nowMoney: this.money * this.count,
          intervalId: this.intervalId,
          intervalName: this.intervalName,
          itemCount: this.count,
          itemRemark: this.itemRemark,
          declareNum: this.declareNum,
        });
        return arr;
      } else {
        this.$notify({
          type: "warning",
          message: "请输入交费金额。",
        });
      }
    },
    onEdit() {
      this.hiddenEdit = false;
    },
    handleMoney(item) {
      if (item.moneys && item.moneys.length > 0) {
        this.moneys = item.moneys.map((x) => {
          return {
            text: x.name + "（" + this.$options.filters.formatMoney(x.money) + "元）",
            value: x.name + "#ABC#" + x.money,
          };
        });
        this.dropDownMoney = this.moneys[0].value;
        // this.money = this.moneys[0].value;
        // this.sumMoney = this.moneys[0].value;
      } else {
        this.money = item.maxMoney;
        this.sumMoney = item.maxMoney;
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      let item = this.item;
      console.log(item);
      if (item) {
        if (item.feeMode === 1) {
          //单一标准 不可改数量
          this.money = item.itemMoney;
          this.sumMoney = item.itemMoney;
        } else if (item.feeMode === 2) {
          //多标准,不可改金额
          this.handleMoney(item);
        } else if (item.feeMode === 3) {
          //自填金额,不可改数量
          this.money = null;
          this.sumMoney = 0;
          item.editMoney = true;
        } else if (item.feeMode === 5 && item.forceConnDeclareWhenCharge === 1) {
          this.declareStd = item.declareStds[0];
          // 收费申报编号
          this.declareNum = this.declareStd.declareNum;
          // 关联收费标准且强制收费时按标准收费且收费标准存在，列出该区间对应的标准
          if (item.forcePayDeclareWhenCharge === 1 && this.declareStd.money) {
            // 如果是强制按照标准缴费
            item.editMoney = false;
            item.canChangeCount = true;
            // 默认缴费金额等于标准金额，可通过修改数量改变
            this.money = this.declareStd.money;
          } else {
            item.editMoney = true;
            item.canChangeCount = false;
            this.money = null;
          }
        } else if (item.feeMode === 5 && item.forceConnDeclareWhenCharge === 0) {
          // 收费规则为按收费申报标准收费，但收费时又不强制关联申报标准，则按照feeMode=3的情况处理，即自填金额
          this.money = null;
          this.sumMoney = 0;
          item.editMoney = true;
          item.canChangeCount = false;
        } else {
          this.handleMoney(item);
        }
        this.showContent = true;
        let interval = this.item.intervals[0];
        if (interval) {
          this.intervalId = interval.intervalId;
          this.intervalName = interval.intervalName;
          this.intervalSpecId = interval.intervalSpecId;
        }
      }
    });
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.charge-card-title {
  /*font-size: 16px;*/
  /*font-weight: bold;*/
  color: #005423;
  background: #e9e9e9;
  height: 6vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 5px 5px 0 0;
}

.flex-form-info {
  height: 38px;
  padding-top: 0px;
  display: flex;
  align-items: center;
  .left {
    min-width: 70px;
    flex: auto;
    text-align: left;
    vertical-align: center;
  }
  .right {
    flex: auto;
    text-align: right;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

.text-field {
  padding-top: 0px;
  padding-right: 0px;
}
/deep/ .van-dropdown-menu__bar {
  position: relative;
  display: flex;
  background-color: #fff;
  height: auto;
  box-shadow: 0 2px 12px rgba(100, 101, 102, 0.12);
  border-bottom: 1px solid #ccc;
}
/deep/ .van-dropdown-menu__title::after {
  position: absolute;
  top: 50%;
  right: -4px;
  margin-top: -5px;
  border: 4px solid;
  border-color: transparent transparent #bec0c1 #bec0c1;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  opacity: 0.9;
  content: "";
}
/deep/ .van-dropdown-menu__title--down::after {
  margin-top: -1px;
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
}
/deep/ .van-dropdown-menu__title--active::after {
  border-color: transparent transparent currentColor currentColor;
}
.link {
  text-decoration: underline;
  color: #005423;
}
.mobile-card {
  /deep/ .card-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1vh 0 1vh 0;
  }
}
/deep/ .van-checkbox__icon .van-icon {
  border-color: #ababab;
}

/deep/ .van-checkbox__label {
  color: #005423;
}

/deep/ .van-field {
  font-size: 16px;
}

/deep/ .van-field__label {
  text-align: left;
}

/deep/ .flex-form-info {
  height: 38px;
  padding-top: 0px;
}

/deep/ .van-dropdown-item__content {
  width: 90%;
  left: 5%;
}

/deep/ .van-dropdown-menu__title {
  font-size: 14px;
}
</style>
